import { useState } from "react";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarInput,
} from "@/components/ui/sidebar"; // This is sample data.
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { NotificationList } from "@/features/Notifications/notification-list.tsx";
import { useNotifications } from "@/hooks/useNotifications";
import { RequestList } from "@/features/Notifications/RequestList.tsx";

export function SidebarRight({
  showNotifications,
  showRequests,
}: {
  showNotifications: boolean;
  showRequests: boolean;
}) {
  const [toggle, setToggle] = useState<boolean>(false);
  const notifications = useNotifications();

  return (
    <Sidebar
      className="h-[970px] w-[340px] mt-2 bg-gray-100 dark:bg-gray-900  hidden flex-2 md:flex rounded-md"
      collapsible="none"
    >
      <SidebarHeader className="gap-3.5 border-b border-gray-600 dark:border-gray-700 p-4">
        <div className="flex flex-row gap-10 w-full items-center justify-between">
          <div className="text-base font-medium text-foreground">
            {showRequests ? "Requests" : "Notifications"}
          </div>
          <Label className="flex items-center gap-2 text-sm">
            <span>{!toggle ? "Unread" : "read"}</span>
            <Switch
              className="shadow-none"
              onClick={() => setToggle(!toggle)}
            />
          </Label>
        </div>
        <SidebarInput placeholder="Type to search..." />
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup className="px-0">
          <SidebarGroupContent>
            {showNotifications && (
              <NotificationList notifications={notifications.data} />
            )}
            {showRequests && <RequestList />}
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
